import queryString from 'query-string';
import api from '../api';
// import router from '../router';

export default {
    namespaced: true,
    state: {
        notifications: null,
        relatedRoutes: {
            property: 'property',
            viewProperty: 'view-property',
            account: 'my-account',
            calendar: 'my-calendar'
        }
    },
    getters: {
        getRelatedLink: state => ({ target_type = null, target_id = null, target_route = null }) => {
            const to = {};
            if (target_type && target_id) {
                to.name = state.relatedRoutes[target_type];
                to.params = {
                    id: target_id
                };
            }
            if (target_route) {
                to.name = state.relatedRoutes[target_route];
            }
            return to;
        }
    },
    mutations: {
        notifications(state, value) {
            state.notifications = value;
        }
    },
    actions: {
        clear({ commit }) {
            return new Promise((resolve) => {
                commit('notifications', null);
                resolve();
            });
        },
        getNotifications({ commit }, params) {
            const query = params ? `?${queryString.stringify(params)}` : null;
            return api.get(`notifications${query}`)
                .then((response) => {
                    commit('notifications', response.data.payload.notifications);
                })
                .catch(() => {

                });
        },
        markAsRead({ commit, dispatch, rootState, state }, { context = '', notificationIds, refresh = false }) {
            return api.patch(`notifications`, {
                action: 'read',
                notificationIds
            })
                .then(() => {
                    if (refresh) {
                        dispatch('user/refreshUser', null, {
                            root: true
                        });
                        if (context === 'route') {
                            dispatch('getNotifications', state.page);
                        }
                    }
                })
                .catch(() => {

                });
        }
    }
};
